var exports = {
  "S": "xf61da738--bbcc61--pagination-sentinel",
};

module.exports = exports;
